import React, { useState } from "react";
import { Link } from "react-router-dom";
import Sidebar from "../../../../partials/aside/Sidebar";
import httpService from "../../../../../services/httpServices/httpServices";
import helperSpinner from "../../../../../helpers/spinner";
import helperNumbers from "../../../../../helpers/numbers";
import TitleBar from "../../../../partials/content/TitleBar";
import AllPledgeCustomer from "./AllPledgeCustomer";

export default function ListCustomerForPledge() {
  const [user, setUser] = useState();
  const [message, setMessage] = useState();

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const goScrollIntoTag = (tagID) => {
    const element = document.getElementById(tagID);
    element.scrollIntoView();
  };

  const findUser = async () => {
    const userID = document.querySelector("#user-id").value;
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestGetUser = await sendRequestGetUser(userID);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!resultSendRequestGetUser) {
      setUser();
      return;
    }
    setUser({
      ...resultSendRequestGetUser,
      user_id: userID,
    });
    setMessage();
  };

  const sendRequestGetUser = async (userID) => {
    const headersRequest = getHeaderForRequest();
    let result;
    try {
      result = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/user/show-info-customer-coworker/" +
          userID,
        headersRequest
      );
    } catch (error) {
      setMessage({
        type_class: "alert alert-danger",
        text: error.response.data.message,
        class_icon: "fa fa-exclamation-triangle",
      });
      goScrollIntoTag("list-customer");
      return false;
    }

    return result.data.data;
  };

  let messageTag;
  if (message) {
    messageTag = (
      <div key={Math.random()} className={`${message.type_class}`}>
        <i className={`${message.class_icon} pl-2`}></i>
        <span>{message.text}</span>
      </div>
    );
  }

  return (
    <>
      <Sidebar
        openItem="coworker-customer-finance"
        activeItem="all-pledge-for-customer"
      />

      <div className="content-wrapper">
        <TitleBar title="لیست بیعانه" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body" id="list-customer">
              {messageTag}
              <div>
                <div className="alert alert-warning ">
                  <p className="text-justify">
                    <i className="fa fa-info pl-2"></i>
                    توجه داشته باشید :{" "}
                  </p>
                  <ul className="pr-3">
                    <li>
                      <p className="text-justify">
                        جهت مشاهده بیعانه ابتدا شماره کاربر مورد نظر خود را از{" "}
                        <a
                          className="text-primary"
                          style={{ textDecoration: "none" }}
                          target="_blank"
                          href="/user/all-customer-coworker"
                        >
                          بخش کاربران
                        </a>{" "}
                        پیدا کرده و در زیر وارد کنید.
                      </p>
                    </li>
                    <li>
                      <p className="text-justify">
                        شماره کاربر مورد نظر خود را با اعداد لاتین وارد نمایید.
                      </p>
                    </li>
                  </ul>
                </div>
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    findUser();
                  }}
                >
                  <div className="input-group mb-3 w-fit-content">
                    <input
                      onWheel={(event) => event.currentTarget.blur()}
                      type="number"
                      id="user-id"
                      className="form-control"
                      placeholder="شماره کاربر را وارد کنید."
                    />
                    <div className="input-group-append">
                      <button
                        className="btn btn-info"
                        type="button"
                        onClick={(e) => {
                          e.preventDefault();
                          findUser();
                        }}
                      >
                        پیدا کردن کاربر
                      </button>
                    </div>
                  </div>
                </form>
                {user && (
                  <div>
                    <div className="table-responsive">
                      <table className="table table-hilite tbl-td-white-space w-100">
                        <thead>
                          <tr>
                            <td>نام کاربر</td>
                            <td>ایمیل کاربر</td>
                            <td>شماره موبایل کاربر</td>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              {user.first_name} {user.last_name}
                            </td>
                            <td>{user.email}</td>
                            <td dir="ltr">
                              {user.mobile != undefined
                                ? helperNumbers.toPersianNum(
                                    helperNumbers.presentMobileNumber(
                                      user.mobile
                                    )
                                  )
                                : ""}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <AllPledgeCustomer userID={user.user_id} />
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
